/**
 * Created by liuyong on 2021/8/20
 */
import axiox from 'axios'
export default {
  wxMethod: function (title, desc, link, img) {
    const url = window.location.href.split('#')[0]
    axiox.get('/api/wx/jsapi/signature', {
      params: {
        url: url
      }
    }).then((res) => {
      const result = res.data.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: result.appid, // 必填，公众号的唯一标识
        timestamp: result.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.noncestr, // 必填，生成签名的随机串
        signature: result.signature, // 必填，签名
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData'
        ]
      })
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: img, // 分享图标
          success: function () {
            // 设置成功
          }
        })
        wx.updateTimelineShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: img, // 分享图标
          success: function () {
            // 设置成功
          }
        })
      })
    })
  }
}
